module.exports = __webpack_public_path__ + "static/5-8913f2259ef8676652d2b42fcce23bf9.jpg";